import { authService } from '../services/authService.js';
import { localize } from '../services/i18n.js';
import { mountOtpInput } from './OtpInput.js';

export class AuthModal {
  constructor() {
    this.busy = false;
    this.backdropEl = document.createElement('div');
    this.backdropEl.className = 'auth-modal-backdrop';
    this.backdropEl.hidden = true;
    this.backdropEl.setAttribute('role', 'dialog');
    this.backdropEl.setAttribute('aria-modal', 'true');
    this.backdropEl.setAttribute('aria-label', 'Вход и регистрация');
    document.body.append(this.backdropEl);
    this.backdropEl.addEventListener('click', event => { if (event.target === this.backdropEl) this.close(); });
    document.addEventListener('keydown', event => {
      if (!this.isOpen) return;
      if (event.key === 'Escape') this.close();
      if (event.key === 'Tab') {
        const items = [...this.backdropEl.querySelectorAll('button:not(:disabled),input:not(:disabled),a[href]')];
        if (!items.length) { event.preventDefault(); return; }
        if (event.shiftKey && document.activeElement === items[0]) { event.preventDefault(); items.at(-1).focus(); }
        else if (!event.shiftKey && document.activeElement === items.at(-1)) { event.preventDefault(); items[0].focus(); }
      }
    });
    window.addEventListener('fixlan:language_change', () => {
      this.backdropEl.setAttribute('aria-label', 'Вход и регистрация');
      if (this.isOpen && !this.busy) this.renderContent();
      localize(this.backdropEl);
    });
  }
  renderContent() {
    const login = this.activeTab === 'login';
    this.backdropEl.setAttribute('aria-label', 'Вход и регистрация');
    this.backdropEl.innerHTML = `
      <div class="auth-modal-window">
        <div class="auth-modal-header"><div class="auth-modal-title">auth@fixlan.ru</div><button type="button" class="auth-modal-close" aria-label="Закрыть">[ ESC ✕ ]</button></div>
        <div class="auth-tabs">
          <button type="button" class="auth-tab-btn tab-login ${login ? 'active' : ''}" data-tab="login" aria-label="&gt;_ ./login.sh (Вход)"><span class="auth-tab-command">&gt;_ ./login.sh</span><span class="auth-tab-caption"> (Вход)</span></button>
          <button type="button" class="auth-tab-btn tab-register ${!login ? 'active' : ''}" data-tab="register" aria-label="./register.bin (Регистрация)"><span class="auth-tab-command">./register.bin</span><span class="auth-tab-caption"> (Регистрация)</span></button>
        </div>
        <div class="auth-modal-body">
          <form>
            <div class="auth-form-group"><label class="auth-form-label" for="auth-identifier">${login ? 'Логин или email' : 'Имя пользователя (3–32: латиница, цифры, _ и -)'}</label>
            <input class="auth-input" id="auth-identifier" name="identifier" autocomplete="username" required maxlength="${login ? 254 : 32}" ${login ? '' : 'minlength="3" pattern="[A-Za-z0-9_\\-]+"'}></div>
            ${login ? '' : '<div class="auth-form-group"><label class="auth-form-label" for="auth-email">Email</label><input class="auth-input" id="auth-email" name="email" type="email" autocomplete="email" required maxlength="254"></div>'}
            <div class="auth-form-group"><label class="auth-form-label" for="auth-password">Пароль${login ? '' : ' (12–128 символов)'}</label>
            <input class="auth-input" id="auth-password" name="password" type="password" autocomplete="${login ? 'current-password' : 'new-password'}" required minlength="${login ? 1 : 12}" maxlength="128"></div>
            ${login ? '<label class="auth-checkbox-label"><input name="rememberMe" type="checkbox"> Запомнить меня на 30 дней</label>' : '<div class="auth-form-group"><label class="auth-form-label" for="auth-invite">Инвайт (необязательно)</label><input class="auth-input" id="auth-invite" name="inviteCode" autocomplete="off" maxlength="64" pattern="[a-f0-9]{64}"></div>'}
            ${login ? '<fieldset class="auth-form-group otp-fieldset"><legend class="auth-form-label">Код аутентификатора</legend><div class="otp-inputs"></div></fieldset><details class="auth-backup-code"><summary>Войти с резервным кодом</summary><label class="auth-form-label" for="auth-factor">Резервный код</label><input class="auth-input" id="auth-factor" name="factor" autocomplete="off" maxlength="64"></details>' : ''}
            <button class="auth-submit-btn ${login ? 'auth-submit-login' : 'auth-submit-register'}" type="submit">${login ? 'Войти' : 'Создать аккаунт'}</button>
          </form>
          <p><a class="profile-link" href="#recover-mfa">Забыли пароль?</a></p>
          <p><a class="profile-link" href="#recover-mfa">Восстановить без почты</a></p>
          <p><a class="profile-link" href="#resend-verification">Повторить письмо подтверждения</a></p>
          <div class="auth-feedback" role="status" aria-live="polite"></div>
        </div>
      </div>`;
    this.backdropEl.querySelector('.auth-modal-close').addEventListener('click', () => this.close());
    for (const link of this.backdropEl.querySelectorAll('a')) link.addEventListener('click', event => { if (this.busy) event.preventDefault(); else this.close(); });
    for (const tab of this.backdropEl.querySelectorAll('[data-tab]')) tab.addEventListener('click', () => { if (!this.busy) { this.activeTab = tab.dataset.tab; this.renderContent(); this.backdropEl.querySelector('input').focus(); } });
    this.backdropEl.querySelector('form').addEventListener('submit', event => this.submit(event));
    this.otp = login ? mountOtpInput(this.backdropEl.querySelector('.otp-inputs')) : null;
    if (login) this.backdropEl.querySelector('details').addEventListener('toggle', event => {
      this.otp.clear(); this.backdropEl.querySelector('[name="factor"]').value = '';
      this.backdropEl.querySelector('.otp-fieldset').hidden = event.currentTarget.open;
    });
    localize(this.backdropEl);
  }
  async submit(event) {
    event.preventDefault();
    if (this.busy) return;
    const form = event.currentTarget, get = name => form.querySelector(`[name="${name}"]`);
    const values = { identifier: get('identifier').value, password: get('password').value, email: get('email')?.value, inviteCode: get('inviteCode')?.value, rememberMe: get('rememberMe')?.checked ?? false };
    const backup = this.backdropEl.querySelector('details')?.open;
    const factor = backup ? get('factor').value.trim() : this.otp?.value();
    if (!backup && factor && !this.otp.complete()) {
      this.backdropEl.querySelector('.auth-feedback').textContent = 'Введите все шесть цифр кода.';
      this.otp.focus(); return;
    }
    this.busy = true;
    const controls = [...this.backdropEl.querySelectorAll('button,input')]; controls.forEach(control => { control.disabled = true; });
    const feedback = this.backdropEl.querySelector('.auth-feedback'); feedback.className = 'auth-feedback feedback-loading'; feedback.textContent = 'Ожидание ответа сервера…';
    try {
      if (this.activeTab === 'login') await authService.login(values.identifier, values.password, values.rememberMe, factor);
      else await authService.register({ username: values.identifier, email: values.email, password: values.password, inviteCode: values.inviteCode });
      this.busy = false; this.close();
      const user = authService.getCurrentUser();
      if (user && !user.mfaEnabled) window.location.hash = user.role === 'SYSADMIN' ? '#admin/security' : '#security';
    } catch (error) { feedback.className = 'auth-feedback feedback-error'; feedback.textContent = error.message; }
    finally { this.busy = false; controls.forEach(control => { control.disabled = false; }); get('password').value = ''; this.otp?.clear(); if (get('factor')) get('factor').value = ''; }
  }
  open(tab = 'login') {
    if (this.busy) return;
    this.trigger = document.activeElement;
    this.activeTab = tab; this.renderContent(); this.backdropEl.hidden = false;
    this.backdropEl.classList.add('is-open'); this.isOpen = true;
    this.previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
    this.backdropEl.querySelector('input').focus();
  }
  close() {
    if (this.busy || !this.isOpen) return;
    this.backdropEl.classList.remove('is-open'); this.backdropEl.hidden = true; this.isOpen = false;
    this.backdropEl.querySelector('form')?.reset(); document.body.style.overflow = this.previousOverflow;
    if (this.trigger?.isConnected) this.trigger.focus();
  }
}
export const authModal = new AuthModal();
